/* eslint-disable import-x/no-default-export */
import Chance from 'chance';

const chance = new Chance();

export default () => ({
  start: chance.integer({ min: 0, max: 3 }),
  end: chance.integer({ min: 4, max: 7 }),
});
